'use client';

import React from 'react';
import { IFile } from '@sapientpro/sapientpro-data-models';
import { useAtomValue } from 'jotai';
import classNames from 'classnames';
import styles from './IndustryCard.module.scss';
import { Theme, theme } from '../../store/theme';

export type Industry = {
  id: number;
  title: string;
  lightImage: IFile;
  darkImage: IFile;
};

type IndustryCardProps = {
  industry: Industry;
};

const IndustryCard = ({ industry }: IndustryCardProps) => {
  const appTheme = useAtomValue<Theme>(theme);

  const image = appTheme === 'light' ? industry.lightImage : industry.darkImage;

  return (
    <div className={styles.industryCard}>
      <img
        src={image.url}
        alt={image.alternativeText || 'industry'}
        className={styles.industryCard__image}
      />
      <p className={classNames(styles.industryCard__title, 'subtitle')}>{industry.title}</p>
    </div>
  );
};

export default IndustryCard;
